import React from "react";
import { signOut } from "firebase/auth";
import { auth } from "../firebase";
import { useNavigate } from "react-router-dom";

const Header = ({ studentData }) => {
  const navigate = useNavigate();

 const handleLogout = async () => {
    try {
      await signOut(auth);
      navigate("/authentication");
    } catch (error) {
      console.error("Error signing out: ", error);
    }
  };

  return (
    <header className="d-flex align-items-center justify-content-between px-3 py-2 border-bottom bg-white">
      <div className="d-flex justify-content-between align-items-center mb-3">
        <div className="text-secondary small" style={{color: '#ffd600',marginTop:'10px'}}>
          <h6><i className="bi bi-person-fill"></i> Welcome, {studentData?.name || 'Student'}</h6>
        </div>
      </div>
      <button
        type="button"
        className="btn btn-outline-secondary d-flex align-items-center gap-1 fw-semibold"
        onClick={handleLogout}
      >
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="16"
          height="16"
          fill="currentColor"
          className="bi bi-box-arrow-right"
          viewBox="0 0 16 16"
        >
          <path
            fillRule="evenodd"
            d="M10 12.5a.5.5 0 0 1-.5.5h-8a.5.5 0 0 1-.5-.5v-9a.5.5 0 0 1 .5-.5h8a.5.5 0 0 1 .5.5v2a.5.5 0 0 0 1 0v-2A1.5 1.5 0 0 0 9.5 2h-8A1.5 1.5 0 0 0 0 3.5v9A1.5 1.5 0 0 0 1.5 14h8a1.5 1.5 0 0 0 1.5-1.5v-2a.5.5 0 0 0-1 0z"
          />
          <path
            fillRule="evenodd"
            d="M15.854 8.354a.5.5 0 0 0 0-.708l-3-3a.5.5 0 0 0-.708.708L14.293 7.5H5.5a.5.5 0 0 0 0 1h8.793l-2.147 2.146a.5.5 0 0 0 .708.708z"
          />
        </svg>
        Logout
      </button>
    </header>
  );
};

export default Header;
